export const BuildInfo = {timestamp:1770835593000}
